import {isDefined} from '@ls/js-utils';
import scope from 'state/analytics/scope';
import CalcType from 'state/Constants/CalcType';

export default class TraceAnalyticDefinition {
  #traceAnalytic;
  #tracePeriod;
  #calcType;
  #traceAnalyticGroupingField;

  findTraceAnalyticLabel = (options) => {
    return options?.find(option => option.value === this.#traceAnalytic)?.label;
  };

  findTracePeriodLabel = (options) => {
    return options?.find(option => option.value === this.#tracePeriod)?.label;
  };

  constructor(props = {}) {
    const {traceAnalytic, tracePeriod, calcType} = props;
    this.#traceAnalytic = traceAnalytic;
    this.#tracePeriod = tracePeriod;
    this.#calcType = calcType;
    this.#traceAnalyticGroupingField = traceAnalytic
      ? traceAnalytic.split('_')
        .map(w => w.toLowerCase())
        .map((lowerCaseTraceAnalyticPartial, idx) => {
          if (idx === 0) {
            return lowerCaseTraceAnalyticPartial;
          }
          return lowerCaseTraceAnalyticPartial[0].toUpperCase() + lowerCaseTraceAnalyticPartial.slice(1);
        })
        .join('')
      : null;
  }

  get traceAnalytic() {
    return this.#traceAnalytic;
  }

  get tracePeriod() {
    return this.#tracePeriod;
  }

  get calcType() {
    return this.#calcType;
  }

  get traceAnalyticGroupingField() {
    return this.#traceAnalyticGroupingField;
  }

  get key() {
    return `${scope} - ${this.#traceAnalytic}, ${this.#tracePeriod}, ${this.#calcType}`;
  }

  get complete() {
    return isDefined(this.#traceAnalytic) && isDefined(this.#tracePeriod) && isDefined(this.#calcType);
  }

  static getDefault = () => new TraceAnalyticDefinition({
    traceAnalytic: "VOLUME_TOTAL",
    tracePeriod: "DAYS_030",
    calcType: CalcType.Account,
  });

  copy = () => ({
    traceAnalytic: this.#traceAnalytic,
    tracePeriod: this.#tracePeriod,
    calcType: this.#calcType,
  });

  setTraceAnalytic = (value) => new TraceAnalyticDefinition({
    ...this.copy(),
    traceAnalytic: value,
  });

  setTracePeriod = (value) => new TraceAnalyticDefinition({
    ...this.copy(),
    tracePeriod: value,
  });

  setCalcType = (value) => new TraceAnalyticDefinition({
    ...this.copy(),
    calcType: value,
  });
}